import React from 'react';
import btn from 'legacy/src/utility/btn';
import cursor from 'legacy-src/utility/Cursor';
import ItemSelector from 'legacy/src/components/content/editor/ItemSelector';
import ContentEditor from 'legacy/src/components/content/editor/ContentEditor';
import defaultContents from 'legacy/src/components/content/editor/types/defaultContents';
import { transformForEditing } from 'legacy/src/components/content/transformations';

const defaults = {};

class EmbedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { ...this.props.data },
    };

    this.chooseType = this.chooseType.bind(this);
  }

  chooseType(type) {
    this.setState({
      data: {
        type,
        content:
          this.props.data || defaults[type] || defaultContents[type] || {},
      },
    });
  }

  clickHandler = () => {
    const { data } = this.state;

    if (data && data.type) {
      switch (data.type) {
        case 'media/image':
        case 'media/audio':
          if (data.content.src === 'url...') {
            return;
          }
          break;
        case 'media/math':
          if (_.isEmpty(data.content)) {
            return;
          }
          break;
        default:
          break;
      }
      this.props.update(data);
      this.props.close();
    }
  };

  render() {
    let { data } = this.state;
    // eslint-disable-next-line no-unused-vars
    const button = { size: 'small', ...this.props.button };

    const cancelButton = (
      <button className={btn({ color: 'gray' })} onClick={this.props.close}>
        Cancel
      </button>
    );

    if (data.type) {
      data = transformForEditing(data.content ? data : { content: data });
      let itemCursor = cursor(data, [], (data) => {
        this.setState({ data });
      });

      return (
        <div>
          <ContentEditor cursor={itemCursor} />
          <button className={btn()} onClick={this.clickHandler}>
            Save
          </button>
          {cancelButton}
        </div>
      );
    }

    return (
      <div>
        <ItemSelector
          types={['media/image', 'media/math', 'media/audio']}
          onAdd={this.chooseType}
        />
        {cancelButton}
      </div>
    );
  }
}
export default EmbedModal;
